import React, { useState } from 'react';
import '../../Css/aboutImg.css';


function AboutImg({ cargo, Nome, Formacao, urlpic }) {




  return (
    <div className="team-card">
      <div className="team-img">
        {urlpic ? (
          <img src={urlpic} alt={Nome} />
        ) : (
          <div className={`avatar ${Nome.replace(/\s/g, '').toLowerCase()}`} />
        )}
      </div>

      <div className="team-info">
        <h4>{Nome}</h4>
        <span>{cargo}</span>
        <p>{Formacao}</p>
      </div>
    </div>
  );
}

export default AboutImg;
